// extracted by mini-css-extract-plugin
export default {"component":"EFR1c"};